import HeroSection from './components/HeroSection';
import ComicGrid from './components/ComicGrid';
import CategorySection from './components/CategorySection';
import FAQSection from './components/FAQSection';
import StatsBanner from './components/StatsBanner';
import JsonLd from '@/components/feature/JsonLd';
import { comics, siteInfo } from '@/mocks/comics';

export default function Home() {
  const recommended = comics.filter((c) => c.isRecommended);
  const hot = comics.filter((c) => c.isHot);
  const latest = comics.filter((c) => c.isNew);
  const completed = comics.filter((c) => c.status === '已完结');

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫画网',
    url: 'https://www.hanmanhua.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.hanmanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫画网',
    url: 'https://www.hanmanhua.com',
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '上海',
    },
  };

  return (
    <>
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={organizationJsonLd} />

      <main>
        <HeroSection />

        <ComicGrid
          title="编辑推荐"
          subtitle="精选优质韩漫，口碑与品质的双重保证"
          comics={recommended}
          viewAllLink="/category/all"
        />

        <StatsBanner />

        <CategorySection />

        <ComicGrid
          title="热门连载"
          subtitle="全民追更的热门韩漫，每一部都不容错过"
          comics={hot}
          viewAllLink="/category/all"
        />

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                  最新更新
                </h2>
                <p className="mt-2 text-sm text-foreground-600">刚刚更新的热门章节，追更党必看</p>
              </div>
              <a href="/category/all" className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap">
                查看全部 <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
            <div className="space-y-3">
              {latest.slice(0, 6).map((comic) => {
                const newChapter = comic.chapters.find((ch) => ch.isNew);
                return (
                  <a
                    key={comic.id}
                    href={`/comic/${comic.id}`}
                    className="flex items-center gap-4 p-4 bg-background-50 rounded-lg hover:bg-background-100 transition-colors group"
                  >
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      className="w-14 h-14 md:w-16 md:h-16 rounded-md object-cover shrink-0"
                    />
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                        {comic.title}
                      </h4>
                      <p className="text-xs text-foreground-500 mt-0.5">
                        {comic.author} · {comic.category} · 共{comic.totalChapters}话
                      </p>
                    </div>
                    {newChapter && (
                      <div className="text-right shrink-0">
                        <span className="block text-xs md:text-sm text-primary-600 font-medium">
                          {newChapter.title}
                        </span>
                        <span className="text-xs text-foreground-400">{newChapter.updateDate}</span>
                      </div>
                    )}
                    <i className="ri-arrow-right-s-line text-foreground-400 hidden sm:block"></i>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        <ComicGrid
          title="经典完结"
          subtitle="已完结的高分韩漫，一口气看到爽"
          comics={completed}
          viewAllLink="/category/all"
        />

        <FAQSection />
      </main>
    </>
  );
}